import React from "react";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Star, GraduationCap, Clock, Award, User } from "lucide-react";
import { clinicData } from "../mock";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const director = {
  id: "director",
  name: "Dr. Harish Jasti",
  credentials: "B.P.T. PGDSP (Apollo), M.P.T (Ortho & Sports)",
  specialty:
    "Fellowship in Osteopathy, Diploma in Master of Chiropractor (Ackermann College, Sweden) ",
  // experience: '22+ years',
  description:
    "Certified in advanced treatments, including dry needling, instrument-assisted mobilization, and manual therapy.",
  image: "/Harish Jasti.webp", 
};

const OurSpecialists = () => {
  // Filter out the director if present in teamMembers
  const otherDoctors = clinicData.teamMembers.filter(
    (member) => member.name !== director.name
  );

  const navigate = useNavigate();
  const handleBookAppointment = () => navigate("/book-appointment");
  return (
    <section id="team" className="py-20 bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-50/30 to-transparent"></div>
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-[#204080]/5 rounded-full blur-3xl -translate-x-1/2"></div>
      <div className="absolute top-1/4 right-0 w-80 h-80 bg-[#2E5AAC]/5 rounded-full blur-3xl translate-x-1/3"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-3 bg-[#204080]/10 text-[#204080] px-5 py-3 rounded-full text-base font-semibold mb-6">
            <GraduationCap size={20} />
            <span>Meet Our Specialists</span>
          </div>

          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#204080] to-[#3a5bb8] drop-shadow-sm mb-4 tracking-tight leading-snug font-serif">
            Qualified Professionals Dedicated to Your Care
            {/* <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#204080] to-[#2E5AAC]">
              Dedicated to Your Care
            </span> */}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed font-serif">
            Our distinguished team of certified physiotherapists brings decades
            of combined experience and specialized expertise to deliver
            exceptional patient outcomes.
          </p>
        </div>

        {/* Director/Fouder Card */}
        <div className="mb-12 flex justify-center">
          <Card className="group overflow-hidden bg-white shadow-2xl border-0 transition-all duration-500 transform hover:-translate-y-2 max-w-sm w-full">
            <div className="relative overflow-hidden">
              <img
                src={director.image}
                alt={director.name}
                className="w-full h-72 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute top-4 left-4 bg-gradient-to-r from-blue-600 to-blue-800 text-white px-4 py-1 rounded-full shadow-lg flex items-center space-x-2">
                <User size={16} />
                <span className="font-semibold text-sm">Director</span>
              </div>
            </div>
            <div className="p-6 space-y-4">
              <div className="space-y-2">
                <h3 className="text-2xl font-bold text-[#204080] group-hover:text-[#2E5AAC] transition-colors duration-300">
                  {director.name}
                </h3>
                <div className="space-y-1">
                  <Badge
                    variant="outline"
                    className="text-[#204080] border-[#204080]/30"
                  >
                    {director.credentials}
                  </Badge>
                </div>
              </div>
              <div className="space-y-2">
                <p className="text-gray-700 font-medium">
                  {director.specialty}
                </p>
                {/*
                  <div className="flex items-center space-x-2 text-gray-500">
                    <Award size={14} />
                    <span className="text-sm">{director.experience}</span>
                  </div>
                  */}
              </div>
              <p className="text-gray-600 leading-relaxed mb-2">
                {director.description}
              </p>
              <div className="flex justify-end">
                <Link
  to="/harish-jasti"
  className="text-[#204080] hover:text-blue-800 font-semibold text-sm"
>
  Learn more about Dr. Harish Jasti, Chief Physiotherapist
</Link>

              </div>
            </div>
          </Card>
        </div>

        {/* Other Doctors */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {otherDoctors.map((member) => (
            <Card
              key={member.id}
              className="group overflow-hidden bg-white shadow-lg hover:shadow-2xl border-0 transition-all duration-500 transform hover:-translate-y-2"
            >
              {/* Member Photo */}
              <div className="relative overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-72 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#204080]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-4 left-4 right-4 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
                  <p className="text-xs text-blue-100 line-clamp-2">
                    {member.description}
                  </p>
                </div>
              </div>

              {/* Member Info */}
              <div className="p-6 space-y-4">
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-[#204080] group-hover:text-[#2E5AAC] transition-colors duration-300">
                    {member.name}
                  </h3>
                  <Badge
                    variant="outline"
                    className="text-[#204080] border-[#204080]/30"
                  >
                    {member.credentials}
                  </Badge>
                </div>
                <p className="text-gray-700 font-medium">{member.specialty}</p>
                <span className="text-sm text-gray-500">
                  {member.experience}
                </span>
              </div>
            </Card>
          ))}
        </div>

        {/* Team Stats and CTA remain unchanged */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl border border-blue-100">
            <div className="text-3xl font-bold text-[#204080] mb-2">50+</div>
            <div className="text-gray-600 text-sm">
              Combined Years Experience
            </div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl border border-blue-100">
            <div className="text-3xl font-bold text-[#204080] mb-2">75+</div>
            <div className="text-gray-600 text-sm">
              Professional Certifications
            </div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl border border-blue-100">
            <div className="text-3xl font-bold text-[#204080] mb-2">100%</div>
            <div className="text-gray-600 text-sm">Board Certified</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl border border-blue-100">
            <div className="text-3xl font-bold text-[#204080] mb-2">23+</div>
            <div className="text-gray-600 text-sm">Specialized Areas</div>
          </div>
        </div>
        <div className="mt-16 text-center">
          <Card className="max-w-4xl mx-auto p-8 bg-gradient-to-r from-[#204080] to-[#2E5AAC] text-white border-0 shadow-2xl">
            <h3 className="text-2xl font-bold mb-4">
              Ready to Meet Your Care Specialists?
            </h3>
            <p className="text-blue-100 mb-6 text-lg">
              Schedule a consultation to discuss your needs with one of our
              expert physiotherapists
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                className="px-8 py-3 bg-white text-[#204080] font-semibold rounded-lg hover:bg-blue-50 transition-colors duration-300 shadow-lg"
                onClick={handleBookAppointment}
              >
                Schedule Consultation
              </button>
              <button
                className="px-8 py-3 border-2 border-white text-white hover:bg-white hover:text-[#204080] font-semibold rounded-lg transition-all duration-300"
                onClick={() => {
                  const el = document.getElementById("team");
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                Learn More About Our Specialists
              </button>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default React.memo(OurSpecialists);
